import { render } from "./iconTick.vue?vue&type=template&id=b0603c6e"
import script from "./iconTick.vue?vue&type=script&lang=js"
export * from "./iconTick.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__